import { errorHandler } from '@/lib/ErrorHandler';
import { getClient } from '@/lib/restClient';
import { SortObject } from '@/pages/menu-managements/services/searchItem';
import { Title } from '@/pages/menu-managements/services/title';
import { MenuManagementBrandCategoryService } from '@/services/BrandCategory/MenuManagementBrandCategoryService';

export type MenuManagementBrandCategoryCreateParams = {
  associate_brand_id: number;
  title: Title;
  memo: string | null;
  brand_item_sort_objects: SortObject[];
};

export const useMenuManagementCreateBrandCategory = async (
  params: MenuManagementBrandCategoryCreateParams
): Promise<void> => {
  const menuManagementBrandCategoryService =
    new MenuManagementBrandCategoryService(getClient());

  return menuManagementBrandCategoryService
    .create(params)
    .catch((error: Error) => errorHandler({ error }));
};
